export enum AppName {
    sigmasms = 'sigmasms',
    imlink = 'imlink'
}